export default {
  'result.success.title': 'Submission Success'
}
